import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import React, { useState } from "react";

import { Drawer } from "../../components/Drawer";
import { OPTIONS_SYSTEM } from "../../constants";
import { CfSelect as Select } from "../../components/CfSelect";

export default function TemplateModal({
  id,
  isOpen,
  setOpen,
  onSubmit,
  defaults,
  errorMessage,
}) {
  const [name, setName] = useState(defaults?.name ?? "");
  const [description, setDescription] = useState(defaults?.description ?? "");
  const [vector, setVector] = useState(defaults?.vector ?? "");
  const [active, setActive] = useState(defaults?.active ?? true);
  const footer = (
    <>
      <div className="text-danger me-auto">{errorMessage}</div>
      <Button color="secondary" onClick={() => setOpen(false)}>
        Cancel
      </Button>
      <Button
        form="uploadTemplate"
        type="submit"
        color="primary"
        className="btn"
        onClick={(e) => {
          e.preventDefault();
          onSubmit({ name, vector, active, description, id });
          setOpen(false);
        }}
      >
        {id ? "Update" : "Create"}
      </Button>
    </>
  );

  return (
    <Drawer
      isOpen={isOpen}
      onClose={() => setOpen(false)}
      title={`${id ? "Update" : "Create"} template`}
      footer={footer}
    >
      <Form id="uploadTemplate">
        <FormGroup>
          <Label>Name</Label>
          <Input value={name} onChange={(e) => setName(e.target.value)} />
        </FormGroup>
        <FormGroup>
          <Label>Description</Label>
          <Input
            type="textarea"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <Label>Vector</Label>
          <Select
            value={OPTIONS_SYSTEM.find((e) => e.value === vector)}
            onChange={(e) => setVector(e?.value ?? "")}
            options={OPTIONS_SYSTEM}
          />
        </FormGroup>
        <FormGroup check>
          <Label check>
            <Input
              checked={active}
              type="checkbox"
              onChange={() => setActive((v) => !v)}
            />{" "}
            Active
          </Label>
        </FormGroup>
      </Form>
    </Drawer>
  );
}
